import { Link } from "react-router-dom";
import { Building2, Users, UserCheck, Package } from "lucide-react";
import { DashboardCard } from "@/shared/ui/DashboardCard";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { adminPlatformMetrics } from "../../data";
import { platformMetricRoutes } from "../../navigation/dashboardRoutes";

const metricIcons = {
  providers: Building2,
  employees: Users,
  beneficiaries: UserCheck,
  packages: Package,
};

export function PlatformMetricsWidget() {
  const { t } = useTranslation();

  return (
    <DashboardCard title={t.safecheck.adminDashboard.platformMetrics}>
      <div className="grid grid-cols-2 gap-3">
        {adminPlatformMetrics.map((metric) => {
          const Icon = metricIcons[metric.key as keyof typeof metricIcons];
          const label =
            t.safecheck.adminDashboard.metrics[metric.key as keyof typeof t.safecheck.adminDashboard.metrics];

          return (
            <Link
              key={metric.key}
              to={platformMetricRoutes[metric.key] ?? "/dashboard/admin"}
              className="hover-zoom block rounded-xl border border-border bg-card-muted/50 p-4 transition-all hover:border-accent/40 hover:bg-card-muted/80"
            >
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-soft">
                <Icon size={18} className="text-primary" />
              </div>
              <p className="mt-3 text-xl font-bold text-foreground">
                {metric.value.toLocaleString()}
              </p>
              <p className="mt-0.5 text-xs text-muted">{label}</p>
            </Link>
          );
        })}
      </div>
    </DashboardCard>
  );
}
